export const getRealm = (url: string): string | false => {
  if (import.meta.env.VITE_KEYCLOAK_REALM) {
    return import.meta.env.VITE_KEYCLOAK_REALM;
  }

  const subdomainMatch = url.match(/^(https?:\/\/)?([a-zA-Z0-9-]+)\./);

  if (subdomainMatch && subdomainMatch[2]) {
    const subdomain = subdomainMatch[2];

    if (subdomain === 'app') {
      return false;
    }

    const enterpriseMatch = subdomain.match(/^([a-zA-Z0-9-]+)-app$/);

    if (enterpriseMatch && enterpriseMatch[1]) {
      return enterpriseMatch[1];
    }
  }

  return false;
};
